import HabitSmallAction from '../views/HabitSmallAction'
import beforeEnter from './beforeEnter'

export default {
  path: '/habit-small-action',
  name: 'habit-small-action',
  component: HabitSmallAction,
  meta: {
    title: '習慣の編集',
    isSubview: true
  },
  beforeEnter: beforeEnter()
}
